<template>
  <div>
    <Hedaers />
    <router-view style="padding-bottom:506px;" :key="key" />
    <Bottoms />
  </div>
</template>

<script>
import Hedaers from '@/layout/Header.vue'
import Bottoms from '@/layout/Bottom.vue'
export default {
    name:'Layout',
    components:{Hedaers,Bottoms},
    computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style>

</style>